/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featureaititle3Inputs */

const zh_about_featureaititle3 = /** @type {(inputs: About_Featureaititle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 驱动内容创作`)
};

const en_about_featureaititle3 = /** @type {(inputs: About_Featureaititle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-Powered Content Creation`)
};

const es_about_featureaititle3 = /** @type {(inputs: About_Featureaititle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creación de contenido con IA`)
};

/**
* | output |
* | --- |
* | "AI-Powered Content Creation" |
*
* @param {About_Featureaititle3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featureaititle3 = /** @type {((inputs?: About_Featureaititle3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featureaititle3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featureaititle3(inputs)
	if (locale === "en") return en_about_featureaititle3(inputs)
	return es_about_featureaititle3(inputs)
});
export { about_featureaititle3 as "about_featureAITitle" }